import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";
const Portfolio = ({ classicHeader, darkTheme }) => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();

  const filters = {
    DESIGN: "Desing",
    VIDEO: "Video",
  };

  const projectsData = [
    {
      title: "Project - About Homesy",
      projectInfo:
        "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
      industry: "Marketing",
      date: "Feb - Mar, 2024",
      url: {
        name: "About Homesy",
        link: "https://www.instagram.com/p/C5q4JvfLOl_/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%253D%253D",
      },
      socialLinks: {
        facebook: "http://www.facebook.com/",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "http://www.instagram.com/",
        mail: "mailto:example@gmail.com",
      },
      thumbImage: "projects/About_Homesy/1.png",
      sliderImages: [
        "projects/About_Homesy/2.png",
        "projects/About_Homesy/3.png",
      ],
      categories: [filters.DESIGN],
    },
    {
      title: "Project - Advertise of Rent-To-Own",
      projectInfo:
        "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
      industry: "Marketing",
      date: "Feb - Mar, 2024",

      socialLinks: {
        facebook: "http://www.facebook.com/",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "http://www.instagram.com/",
        mail: "mailto:example@gmail.com",
      },
      thumbImage: "projects/Advantage_of _Rent_To_Own/1.png",
      categories: [filters.DESIGN],
    },
    {
      title: "Project - Breaking News",
      projectInfo:
        "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
      industry: "Marketing",
      date: "Feb - Mar, 2024",
      url: {
        name: "Breaking News",
        link: "https://www.instagram.com/p/C5q4JvfLOl_/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D&img_index=1",
      },
      socialLinks: {
        facebook: "http://www.facebook.com/",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "http://www.instagram.com/",
        mail: "mailto:example@gmail.com",
      },
      thumbImage: "projects/Breaking_News/1.png",
      sliderImages: [
        "projects/Breaking_News/2.png",
        "projects/Breaking_News/3.png",
        "projects/Breaking_News/4.png",
      ],
      categories: [filters.DESIGN],
    },
    {
      title: "Project - Newsletter Vol.3",
      projectInfo:
        "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
      industry: "Marketing",
      date: "Feb - Mar, 2024",
      socialLinks: {
        facebook: "http://www.facebook.com/",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "http://www.instagram.com/",
        mail: "mailto:example@gmail.com",
      },
      thumbImage: "projects/Newsletter_Vol.3/1.png",
      sliderImages: [
        "projects/Newsletter_Vol.3/2.png",
        "projects/Newsletter_Vol.3/3.png",
        "projects/Newsletter_Vol.3/4.png",
      ],
      categories: [filters.DESIGN],
    },
    {
      title: "Project - Newsletter Vol.4",
      projectInfo:
        "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
      industry: "Marketing",
      date: "Feb - Mar, 2024",
      socialLinks: {
        facebook: "http://www.facebook.com/",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "http://www.instagram.com/",
        mail: "mailto:example@gmail.com",
      },
      thumbImage: "projects/Newsletter_Vol.4- april/1.png",
      sliderImages: [
        "projects/Newsletter_Vol.4- april/2.png",
        "projects/Newsletter_Vol.4- april/3.png",
        "projects/Newsletter_Vol.4- april/4.png",
      ],
      categories: [filters.DESIGN],
    },
    {
      title: "Project - Newsletter Vol.6",
      projectInfo:
        "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
      industry: "Marketing",
      date: "Feb - Mar, 2024",

      socialLinks: {
        facebook: "http://www.facebook.com/",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "http://www.instagram.com/",
        mail: "mailto:example@gmail.com",
      },
      thumbImage: "projects/Newsletter_Vol.6- april/1.png",
      sliderImages: [
        "projects/Newsletter_Vol.6- april/2.png",
        "projects/Newsletter_Vol.6- april/3.png",
        "projects/Newsletter_Vol.6- april/4.png",
      ],
      categories: [filters.DESIGN],
    },
    {
      title: "Project - Newsletter Vol.7",
      projectInfo:
        "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
      industry: "Marketing",
      date: "Feb - Mar, 2024",
      socialLinks: {
        facebook: "http://www.facebook.com/",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "http://www.instagram.com/",
        mail: "mailto:example@gmail.com",
      },
      thumbImage: "projects/Newsletter_Vol.7- June/1.png",
      sliderImages: [
        "projects/Newsletter_Vol.7- June/2.png",
        "projects/Newsletter_Vol.7- June/3.png",
        "projects/Newsletter_Vol.7- June/4.png",
        "projects/Newsletter_Vol.7- June/5.png",
        "projects/Newsletter_Vol.7- June/6.png",
        "projects/Newsletter_Vol.7- June/7.png",
      ],
      categories: [filters.DESIGN],
    },
    {
      title: "Project - Bank vs Homesy",
      projectInfo:
        "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
      industry: "Marketing",
      date: "Feb - Mar, 2024",
      url: {
        name: "Bank vs Homesy",
        link: "https://www.instagram.com/p/C5B0NehPCKs/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D",
      },
      socialLinks: {
        facebook: "http://www.facebook.com/",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "http://www.instagram.com/",
        mail: "mailto:example@gmail.com",
      },
      thumbImage: "projects/Banks_Homesy/1.png",
      sliderImages: [
        "projects/Banks_Homesy/2.png",
        "projects/Banks_Homesy/3.png",
        "projects/Banks_Homesy/4.png",
      ],
      categories: [filters.DESIGN],
    },
    {
      title: "Trending Advertisement Campaign on TikTok for Homesy",
      objective:
        "To create brand awareness and increase social media following by utilizing trending video styles and soundtracks on TikTok to promote Homesy.",
      projectInfo:
        "During my tenure at Homesy, I spearheaded a trending advertisement campaign on TikTok aimed at boosting brand awareness and encouraging users to follow Homesy's social media accounts and engage with our posts. This 8-week project leveraged popular video trends and soundtracks to capture the attention of TikTok users.",
      results: [
        "Increased Followers: Significant growth in Homesy's TikTok followers and engagement rates.",
        "Higher Engagement: Increased likes, shares, and comments on TikTok videos.",
        "Brand Awareness: Boosted brand recognition among TikTok users.",
      ],
      conclusion:
        "This campaign successfully utilized TikTok trends to create engaging content, boosting Homesy's brand awareness and social media following. The strategic use of trending video styles and soundtracks captured the attention of a wide audience and encouraged greater interaction with Homesy's online presence.",
      industry: "Marketing",
      date: "Feb - Mar, 2024",
      url: {
        name: "What is Rent-To-Own?",
        link: "https://www.instagram.com/p/C5B0NehPCKs/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D",
      },
      socialLinks: {
        facebook: "http://www.facebook.com/",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "http://www.instagram.com/",
        mail: "mailto:example@gmail.com",
      },
      thumbImage: "projects/WHAT_IS_RENT_TO_OWN.mp4",
      sliderImages: [
        "projects/WHAT_IS_RENT_TO_OWN.mp4",
        "projects/v09044g40000cocpaqnog65rn9jqcff0.mp4",
        "projects/v09044g40000co1ibhnog65hsg5bu5m0.mp4",
      ],
      categories: [filters.VIDEO],
    },
  ];

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
    });

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, []);

  // handling filter key change
  useEffect(() => {
    if (imagesLoaded) {
      filterKey === "*"
        ? isotope.current.arrange({ filter: `*` })
        : isotope.current.arrange({ filter: `.${filterKey}` });
    }
  }, [filterKey, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => setFilterKey(key);

  return (
    <>
      <section
        id="portfolio"
        className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
      >
        <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
          {/* Heading */}
          <div className="position-relative d-flex text-center mb-5">
            <h2
              className={
                "text-24  text-uppercase fw-600 w-100 mb-0 " +
                (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
              }
            >
              Portfolio
            </h2>
            <p
              className={
                "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
                (darkTheme ? "text-white" : "text-dark")
              }
            >
              {" "}
              My Work
              <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
            </p>
          </div>
          {/* Heading end*/}
          {/* Filter Menu */}
          <ul
            className={
              "portfolio-menu nav nav-tabs justify-content-center border-bottom-0 mb-5 " +
              (darkTheme ? "nav-light" : "")
            }
          >
            <li className="nav-item">
              <button
                className={"nav-link " + (filterKey === "*" ? "active" : "")}
                onClick={handleFilterKeyChange("*")}
              >
                All
              </button>
            </li>
            {Object.keys(filters).map((oneKey, i) => (
              <li className="nav-item" key={i}>
                <button
                  className={
                    "nav-link " +
                    (filterKey === filters[oneKey] ? "active" : "")
                  }
                  onClick={handleFilterKeyChange(filters[oneKey])}
                >
                  {filters[oneKey]}
                </button>
              </li>
            ))}
          </ul>
          {/* Filter Menu end */}
          <div className="portfolio popup-ajax-gallery">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div
                    className={
                      "col-sm-6 col-lg-4 filter-item " +
                      project.categories.join(" ")
                    }
                    key={index}
                  >
                    <div className="portfolio-box rounded">
                      <div className="portfolio-img rounded">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt=""
                        />

                        <div className="portfolio-overlay">
                          <a
                            className="popup-ajax stretched-link"
                            href=""
                            onClick={() => {
                              setSelectedProjectDetails(projectsData[index]);
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                          />
                          <div className="portfolio-overlay-details">
                            <h5 className="text-white fw-400">
                              {project.title}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      <div className="project-details-modal">
        {/* Modal */}
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          darkTheme={darkTheme}
        ></ProjectDetailsModal>
      </div>
    </>
  );
};

export default Portfolio;
